import AddRecipeToShoppingList from "@/components/Planner/AddRecipeToShoppingList";
import SaveRecipe from "@/components/SaveRecipe";
import { Recipe } from "@/types/recipe";
import clsx from "clsx";

const RecipeActions = ({ entry }: { entry: Recipe }) => {
  return (
    <>
      <div className={clsx("w-2/5 sm:w-auto")}>
        <SaveRecipe recipe={entry} theme={"dark"} size="lg" showLabel border />
      </div>
      <AddRecipeToShoppingList recipe={entry} />
    </>
  );
};

export default RecipeActions;
